/* 入口文件 */
import Vue from "vue";
import App from "./App";
import router from "./router/index.js";
import store from "./store/index.js"; //vueX 模块
import "./plugins/element.js"; //elementUI配置
import "./plugins/notifyTips.js"; //通知提示框配置
import "./plugins/filters.js"; //全局过滤器
import "./plugins/icons/index.js";
// 导入全局样式表
import "./assets/css/global.less";
// 引入字体样式
import "font-awesome/css/font-awesome.min.css";
import "default-passive-events"; //阻止默认事件行为
import { getUserInfo } from "./api/userApi.js"; //导入api模块
Vue.config.productionTip = false; //关闭生产提示

/* 路由守卫 */
router.beforeEach(async function (to, from, next) {
  const token = window.sessionStorage.getItem("token"); //获取缓存token
  if (!token) {
    /* 检测路由是否需要守卫 */
    if (!to.matched.some((item) => item.meta.login || item.meta.auth)) {
      return next(); //token不存在且路由不需要守卫（路由放行）
    }
    //token不存在但是路由需要守卫(路由重定向--->登录后返回原路由)
    let auth = to.matched.some((item) => item.meta.auth); //判断是否需要权限
    return next({
      path: "/login",
      query: { redirect: to.fullPath, auth },
    });
  }
  try {
    //token存在,验证token信息
    const res = await getUserInfo("/userInfo");
    console.log("测试res:", res);
    if (res.code === 200) {
      /* token 验证成功 用户已登录 */
      if (res.data.status !== 1) {
        store.commit("syncLogout"); //清除登录状态
        Vue.prototype.$message({
          type: "error",
          message: "该账号已封停,如有疑问请联系管理员!",
        });
        return next({ path: "/login" });
      }
      store.commit("syncUserInfo", res.data); //保存用户的信息
      if (!to.matched.some((item) => item.meta.auth)) return next(); //不需要权限(放行)
      if (res.data.isMange) return next(); //有权限访问(放行)
      Vue.prototype.$message({ type: "error", message: "权限不足,无法访问!" });
      let fullPath = from.fullPath;
      if (fullPath === "/") fullPath = "/public";
      return next({ path: `${fullPath}` }); //权限不足,拦截后原路径返回
    }
    /* token 验证失败 */
    store.commit("syncLogout"); //清除登录状态
    if (!to.matched.some((item) => item.meta.login || item.meta.auth)) {
      return next(); //路由不需要守卫
    }
    /* token已失效但是路由需要守卫且访问的是管理员后台管理(路由重定向--->登录后返回原路由) */
    let auth = to.matched.some((item) => item.meta.auth); //判断是否需要权限
    next({ path: "/login", query: { redirect: to.fullPath, auth } });
  } catch (error) {
    console.log("路由守卫:", error);
    store.commit("syncLogout"); //清除登录状态
    next({ path: "/login" });
  }
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
